(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Link", [], factory);
	else if(typeof exports === 'object')
		exports["Link"] = factory();
	else
		root["Link"] = factory();
})(this, function() {
return 